import {api} from '../../contexts/AuthContext';

export const countriesApi = {
    getAll: async (): Promise<{ name: string; code: string }[]> => {
        const response = await api.get('/api/countries');
        return response.data.countries;
    }
};
